export default {
  'nav.home': 'Accueil',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.categories': 'Catégories',
  'nav.guides': 'Guides',
  'nav.reviews': 'Avis',
  'nav.shipping': 'Livraison',
  'nav.safety': 'Sécurité',
  'nav.shoppingGuide': "Guide d'achat",

  // Page headers
  'page.spreadsheet.title': 'Catégories du AllChinaBuy Spreadsheet',
  'page.spreadsheet.subtitle': 'Parcourez toutes les catégories du AllChinaBuy Spreadsheet et accédez directement aux produits recherchés.',
  'page.guides.title': 'Guides et articles AllChinaBuy',
  'page.guides.subtitle': 'Des guides pratiques et originaux sur le QC, la livraison, la sécurité et les conseils d’achat.',
  'page.reviews.title': 'Avis et recherche indépendante sur AllChinaBuy',
  'page.reviews.subtitle': 'Des informations honnêtes et indépendantes pour évaluer AllChinaBuy avant de commander.',
  'page.safety.title': 'Guide de sécurité AllChinaBuy',
  'page.safety.subtitle': 'Une liste pratique pour vérifier les informations et réduire les risques d’achat.',

  'hero.badge': 'Ressource indépendante · Revue régulièrement',
  'hero.title': 'AllChinaBuy Spreadsheet — Trouver, comparer et acheter malin',
  'hero.subtitle': 'Explorez des trouvailles produits organisées, des guides par catégorie, des infos QC, des ressources de livraison et des conseils d’achat pratiques au même endroit. Que vous soyez nouveau sur AllChinaBuy ou acheteur expérimenté, cette ressource vous aide à rechercher des produits, comparer les options et prendre des décisions plus éclairées avant de commander.',
  'hero.searchPlaceholder': 'Rechercher des produits, catégories, vendeurs ou guides…',
  'hero.ctaPrimary': 'Explorer le Spreadsheet',
  'hero.ctaSecondary': 'Acheter maintenant',
  'hero.trustLine': 'Ressource indépendante · Guides utiles · Revue régulièrement',

  'category.title': 'Parcourir par catégorie',
  'category.subtitle': 'Accédez directement à la catégorie dont vous avez besoin sur le site principal.',
  'category.dropdownLabel': 'Choisir une catégorie',
  'category.dropdownPlaceholder': 'Sélectionner une catégorie…',
  'category.viewAll': 'Voir toutes les catégories',
  'category.note': 'Les informations peuvent changer. Vérifiez les détails du produit et du vendeur avant de commander.',

  'cat.shoes': 'Chaussures',
  'cat.hoodies': 'Hoodies / Sweats',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Vestes',
  'cat.pants': 'Pantalons / Shorts',
  'cat.headwear': 'Couvre-chefs',
  'cat.sets': 'Ensembles',
  'cat.underwear': 'Sous-vêtements',
  'cat.jersey': 'Maillots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Sacs',
  'cat.belts': 'Ceintures',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Autres articles',

  'about.title': 'Tout ce qu’il faut pour vos recherches AllChinaBuy',
  'about.subtitle': 'Un point de départ clair et honnête pour comprendre le AllChinaBuy Spreadsheet.',
  'about.paragraph1': 'Le AllChinaBuy Spreadsheet est une collection communautaire de liens produits, de catégories et de ressources d’achat. Il rassemble des trouvailles en chaussures, vêtements, sacs, accessoires et plus, pour que vous puissiez parcourir ce dont vous avez besoin sans chercher partout.',
  'about.paragraph2': 'Ce site est une ressource informationnelle indépendante. Il n’est pas le site officiel d’AllChinaBuy et n’y est pas affilié. Nous expliquons comment fonctionne le spreadsheet, comment évaluer les produits et comment rechercher livraison et QC avant de commander.',

  'feature.spreadsheet.title': 'AllChinaBuy Spreadsheet',
  'feature.spreadsheet.desc': 'Parcourez des trouvailles produits et ressources par catégorie organisées.',
  'feature.qc.title': 'Guides QC',
  'feature.qc.desc': 'Apprenez à lire les photos produits, les détails qualité et les tailles.',
  'feature.shipping.title': 'Livraison',
  'feature.shipping.desc': 'Comprenez les options, coûts, poids et erreurs courantes de livraison.',
  'feature.reviews.title': 'Avis',
  'feature.reviews.desc': 'Lisez des recherches indépendantes et des avis pratiques AllChinaBuy.',
  'feature.safety.title': 'Sécurité',
  'feature.safety.desc': 'Apprenez à vérifier les informations et réduire les risques d’achat.',
  'feature.comparisons.title': 'Comparaisons',
  'feature.comparisons.desc': 'Comparez AllChinaBuy avec d’autres plateformes d’achat populaires.',

  'beginner.title': 'Nouveau sur AllChinaBuy ?',
  'beginner.desc': 'Commencez par notre guide débutant pour comprendre le spreadsheet, évaluer les produits, lire les photos QC et rechercher la livraison avant de commander.',
  'beginner.cta': 'Lire le guide débutant',

  'research.title': 'Renseignez-vous avant d’acheter',
  'research.desc': 'Les liens produits, prix, vendeurs et conditions de livraison peuvent changer. Utilisez ce site comme ressource de recherche et vérifiez les informations avant d’acheter.',
  'research.cta': 'Lire le guide sécurité',

  'guides.title': 'Derniers guides et articles',
  'guides.subtitle': 'Des guides originaux et pratiques pour mieux rechercher.',
  'guides.readMore': "Lire l'article",
  'guides.article1.title': 'Comment utiliser le AllChinaBuy Spreadsheet : guide complet débutant',
  'guides.article1.desc': 'Découvrez ce qu’est le AllChinaBuy Spreadsheet, son organisation, et comment parcourir les catégories et vérifier les produits avant de commander.',
  'guides.article1.meta': 'Un guide débutant du AllChinaBuy Spreadsheet couvrant son fonctionnement, la navigation par catégorie, la recherche produit et les conseils de sécurité.',

  'faq.title': 'Questions fréquentes',
  'faq.subtitle': 'Des réponses rapides aux questions courantes sur le AllChinaBuy Spreadsheet.',
  'faq.q1': 'Est-ce le site officiel d’AllChinaBuy ?',
  'faq.a1': 'Non. C’est une ressource informationnelle indépendante sur le AllChinaBuy Spreadsheet. Nous ne sommes pas affiliés à AllChinaBuy.',
  'faq.q2': 'Qu’est-ce que le AllChinaBuy Spreadsheet ?',
  'faq.a2': 'C’est une collection communautaire de liens produits et de catégories. Elle aide les acheteurs à trouver chaussures, vêtements, sacs et accessoires au même endroit.',
  'faq.q3': 'Les prix et liens changent-ils ?',
  'faq.a3': 'Oui. Les liens, prix, vendeurs et conditions de livraison peuvent changer à tout moment. Vérifiez toujours les informations sur la page produit avant d’acheter.',
  'faq.q4': 'Où mènent les boutons de catégorie ?',
  'faq.a4': 'Les boutons et le menu déroulant de catégorie mènent au site principal pour parcourir la catégorie correspondante.',

  'final.title': 'Prêt à explorer le AllChinaBuy Spreadsheet ?',
  'final.desc': 'Parcourez les dernières ressources, comparez les catégories et continuez vers le site principal quand vous êtes prêt.',
  'final.cta': 'Explorer les ressources AllChinaBuy',

  'footer.tagline': 'Une ressource informationnelle indépendante sur le AllChinaBuy Spreadsheet.',
  'footer.disclaimer': 'Ce site est une ressource informationnelle indépendante et n’est pas le site officiel d’AllChinaBuy. La disponibilité des produits, les prix, les liens, les vendeurs, les options de livraison et les offres peuvent changer. Vérifiez toujours les informations avant d’acheter.',
  'footer.resources': 'Ressources',
  'footer.categories': 'Catégories',
  'footer.legal': 'Mentions légales',
  'footer.home': 'Accueil',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.disclaimerLink': 'Avertissement',
  'footer.rights': 'Tous droits réservés.',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.da': 'Dansk',
  'lang.de': 'Deutsch',

  'article.backHome': "Retour à l'accueil",
  'article.breadcrumbHome': 'Accueil',
  'article.breadcrumbGuides': 'Guides',
  'article.updated': 'Dernière mise à jour',
  'article.readingTime': 'min de lecture',
  'article.keyTakeaways': 'Points clés',
  'article.notFound': 'Article introuvable',
};